import React from 'react';
import type { Moment } from 'moment';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText, HeaderText, Button, Stack,
} from '../../../../../ui';
import ProgressBar from '../../ProgressBar';
import Title from '../../Title';

type ExtendingProps = {
  /** current number of appointments booked */
  currentValue: number;
  onExtendButtonClicked: () => void;
  /** Their possible next deadline for search boost activation */
  deadline: Moment;
};

const Extending = ({ currentValue, onExtendButtonClicked, deadline }: ExtendingProps) => {
  const trackingParams = {
    bookings: currentValue,
  };

  const handleButtonClick = () => {
    onExtendButtonClicked();
  };

  return (
    <Stack
      space={8}
      alignItems="center"
    >
      <Title
        modeText="EARN A"
        headerLevel={2}
        showingExtend
      />
      <HeaderText
        level={4}
        color={colors.slate}
      >
        Get a second chance!
      </HeaderText>
      <BodyText
        appearance="medium"
        textAlign="center"
      >
        <BodyText
          emphasize
          appearance="medium"
          style={{ paddingRight: 4 }}
        >
          {`We'll give you until ${deadline.format('MMMM D')}`}
        </BodyText>
        {`to help earn a search boost.
        Book ${6 - currentValue} more appointments and we’ll push your profile to the top of
        client searches in your area.`}
      </BodyText>
      <ProgressBar
        currentValue={currentValue}
        progressColor={colors.ash}
        disabled
        showExtendBoost
      />
      <Box paddingTop={16}>
        <Button
          testID="extend-search-boost-button"
          text="Extend my time"
          size="medium"
          appearance="primary"
          onClick={handleButtonClick}
          clickTracking={{
            name: 'pro_home_extend_searchboost_click',
            params: trackingParams,
          }}
          style={{
            borderRadius: 4,
            textTransform: 'capitalize',
          }}
        />
      </Box>

    </Stack>
  );
};

export default Extending;
